/* eslint-disable eqeqeq */
import React, { Fragment } from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import nl2br from 'Components/nl2br'
import { isOurID } from 'Components/us'
import moment from 'moment'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
  UncontrolledTooltip as Tooltip,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
  PopoverHeader,
  PopoverBody,
  UncontrolledPopover
} from 'reactstrap'
import { OrderActions, OrderStore } from 'Stores/orderStore'
import { AddressActions } from 'Stores/addressStore'
import { LoginStore } from 'Stores/loginStore'
import styled from 'styled-components'
import _ from 'lodash'
import OrderDetailsForm from 'Modules/OrderDetailsForm.js'
import { AddressStore } from '../stores/addressStore'
import PaginatedTable from '../components/paginatedTable'
import CommentSection from '../components/commentSection'
import { PurchaseOrderStore } from '../stores/purchaseOrderStore'
import OrderTrackingHistory from '../components/orderTrackingHistory'
import { Paper, TableHead, TableRow, TableCell, TableBody, TableContainer, TableFooter } from '@material-ui/core'
import OrderAttachments from '../components/orderAttachments'
import OrderDeliveryDetails from '../components/orderDeliveryDetails'
import NotifyUserModal from '../components/notifyUserModal'
import OrderCommunication from '../components/orderCommunication'

const OrderLineCheckbox = styled.input`
  vertical-align: middle;
`
const AreaSeperator = styled(Table)`
  border-bottom: 1px dashed #ddd;
`

const StyledDropdown = styled(DropdownItem)`
  padding: 0px 40px !important;
  height: 25px !important;
`
const StyledSpan = styled.span`
  all: revert !important;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 0.875rem !important;
  color: #23282c !important;
  cursor: pointer !important;
  &:hover {
    color: ${props => (props.value ? '#23282c' : 'green')}!important;
  }
`
const StyledProductNumberSpan = styled.span`
  &:hover {
    color: green !important;
  }
`

const StyledProductTitleSpan = styled.span`
  all: revert !important;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 0.875rem !important;
  color: #23282c !important;
  cursor: auto !important;
`
const StyledLink = styled(Link)`
  text-decoration: none;
  color: #23282c;
  font-weight: 400;
`

const orderStatus = {
  NEW: 'Ny',
  TENTATIVE: 'Afventer',
  BACKORDER: 'Backorder',
  ORDERED: 'Bestilt',
  PACKED: 'Pakket',
  SHIPPED: 'Sendt',
  RECEIVED: 'Modtaget',
  REFUNDED: 'Refunderet',
  COMPLAINT: 'Reklamation',
  DECLINED: 'Afvist',
  FAILED: 'Fejlet',
  PREORDER: 'Preorder'
}
const seasonOrderStatus = {
  NEW: 'Ny',
  TENTATIVE: 'Afventer',
  ORDERED: 'Bestilt',
  PACKED: 'Pakket',
  SHIPPED: 'Sendt',
  RECEIVED: 'Modtaget',
  TO_ORDER: 'Skal bestilles'
}

const statusColors = {
  NEW: '#042e26',
  TENTATIVE: '#0a6553',
  BACKORDER: '#18b394',
  ORDERED: '#69f2d7',
  PACKED: '#892020',
  SHIPPED: '#dc4040',
  RECEIVED: '#ffc7c7',
  REFUNDED: '#f88c2d',
  COMPLAINT: '#ffdc18',
  DECLINED: '#217188',
  FAILED: '#52c9eb',
  PREORDER: 'orange'
}
const orderColors = { TENTATIVE: 'white', NEW: 'white', PACKED: 'white', DECLINED: 'white' }

export class CustomOrder extends Component {
  render() {
    return ''
  }
}
export const Order = props => {
  if (props.match && props.match.params && props.match.params.OrderID) {
    return <OrderDetails {...props} />
  }
  return <OrderListOverview {...props} />
}

class OrderDetails extends Component {
  constructor(props) {
    super(props)
    this.stores = [OrderStore, AddressStore, LoginStore]
    this.storeKeys = [
      'fetchingSingleOrder',
      'orderDetails',
      'showTooltip',
      'isCustomOrder',
      'addresses',
      'settings',
      'showNotifyModal',
      'notifyUserID',
      'msbAdminUsers',
      'carriers',
      'trackingDetails',
      'trackAndTraceEvents'
    ]
    this.orderStatus = this.props.seasonOrder ? seasonOrderStatus : orderStatus
  }
  componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.OrderID) {
      if (this.state.orderDetails.OrderID != this.props.match.params.OrderID) {
        const orderId = this.props.match.params.OrderID
        OrderActions.getOrder(orderId)
        OrderActions.getTrackingDetails(orderId)
        OrderActions.getCarriers(orderId)

        if (
          this.state.settings &&
          this.state.settings.userRole.toLowerCase() === 'system' &&
          this.state.settings.userPrivilege.toLowerCase() === 'manage'
        ) {
          OrderActions.getMsbAdminUsers()
        }
      }
    }
    AddressActions.getAddresses()
  }
  render() {
    if (this.state.fetchingSingleOrder || this.state.orderDetails.OrderID != this.props.match.params.OrderID) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    let order = this.state.orderDetails
    order.timeline = order.timeline.map(timeline => {
      timeline.timelineEvent = this.orderStatus[timeline.timelineEvent] ? this.orderStatus[timeline.timelineEvent] : timeline.timelineEvent
      return timeline
    })
    const orderId = +this.props.match.params.OrderID

    const totalFreightCurrency = (order.freightPriceDKK || 0) + (order.dropshipPriceDKK || 0)
    const totalFreightPoints = (order.freightPoints || 0) + (order.dropshipPoints || 0)
    const totalOrderAmountPoints = order.orderlines.reduce((sum, line) => sum + (line.orderAmountPoints || 0), 0)
    const showPriceInPoints = totalOrderAmountPoints > 0
    const showDeliveryCostInPoints = showPriceInPoints && !order.deliveryPaidWithCard

    return (
      <Row>
        <Col xs='6'>
          <OrderDetailsForm initialOrderDetails={order} isSeasonOrder={this.props.seasonOrder} addressList={this.state.addresses} />
        </Col>
        <Col xs='6'>
          <CollapsibleCard
            startOpen
            header={
              <React.Fragment>
                <strong>Modtager</strong>
                <Fragment>
                  <Tooltip target={'notify' + order.OrderID}>Send besked</Tooltip>
                  <Button
                    id={'notify' + order.OrderID}
                    onClick={() => {
                      OrderActions.setShowNotifyModal(true, order.OrderID, order.UserID)
                    }}
                    style={{ float: 'right' }}
                  >
                    <span className='fa-layers fa-fw'>
                      <FontAwesomeIcon icon='mail-bulk' />
                    </span>
                  </Button>
                </Fragment>
                <Tooltip target='shipOrder'>Send Ordre</Tooltip>
                <Button
                  style={{ float: 'right', marginRight: '8px' }}
                  onClick={() => {
                    OrderActions.shipOrder(order.OrderID, true, this.props)
                  }}
                  id='shipOrder'
                >
                  <FontAwesomeIcon icon='ship' />
                </Button>
                <Tooltip target='copy'>Copy to clipboard</Tooltip>
                <Button style={{ float: 'right', marginRight: '8px' }} onClick={OrderActions.copyToClipboard} id='copy'>
                  <FontAwesomeIcon icon='copy' />
                </Button>
                <Tooltip target='print'>Print følgeseddel</Tooltip>
                <Button
                  style={{ float: 'right', marginRight: '8px' }}
                  onClick={() => {
                    window.open('/orders/print?OrderID=' + order.OrderID, '_blank')
                  }}
                  id='print'
                >
                  <FontAwesomeIcon icon='print' />
                </Button>
              </React.Fragment>
            }
          >
            <div id='deliveryInfo'>
              {order.orderConsigneeName}
              <br />
              {order.orderConsignee && (
                <Fragment>
                  Att: {order.orderConsignee}
                  <br />
                </Fragment>
              )}
              {order.orderConsigneeAddress1}
              <br />
              {order.orderConsigneeAddress2 && (
                <Fragment>
                  Att: {order.orderConsigneeAddress2}
                  <br />
                </Fragment>
              )}
              {order.orderConsigneeZipcode} {order.orderConsigneeCity}
              <br />
              <em>{order.orderConsigneePhone}</em>
              <br />
              <em>{order.orderConsigneeEmail}</em>
              <br />
              <em>{order.orderConsigneeCustomerNumber ? 'CN: ' + order.orderConsigneeCustomerNumber : ''}</em>
            </div>
            <br />
            {(order.freightPoints > 0 || order.dropshipPoints > 0) && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>Fragt info:</span>
                {
                  <span style={{ marginTop: 4 }}>
                    Fragt: {showDeliveryCostInPoints ? `${order.freightPoints} point` : `${order.freightPriceDKK} kr`}
                  </span>
                }
                {<span>Dropship: {showDeliveryCostInPoints ? `${order.dropshipPoints} point` : `${order.dropshipPriceDKK} kr`}</span>}
                <span>Total fragt: {showDeliveryCostInPoints ? `${totalFreightPoints} point` : `${totalFreightCurrency} kr`}</span>
                {order.orderFlowStatus === 'REFUNDED' && <span>{order.refundFreight ? 'Fragt refunderes' : 'Fragt refunderes ikke'}</span>}
              </div>
            )}
          </CollapsibleCard>

          <OrderDeliveryDetails OrderID={orderId} />

          <OrderAttachments OrderID={orderId} CustomOrder={order.orderCustomOrder} />

          <CollapsibleCard startOpen header={<strong>Track & Trace</strong>}>
            <Label for='CarrierID'>Transportør</Label>
            <Input
              type='select'
              name='CarrierID'
              id='CarrierID'
              placeholder='Ingen'
              onChange={e => OrderActions.setOrderCarrier(e.target.value)}
              value={this.state.trackingDetails.CarrierID}
            >
              <option key={0} value={null}>
                Ingen
              </option>
              {this.state.carriers.map(c => {
                return (
                  <option key={c.CarrierID} value={c.CarrierID}>
                    {c.name}
                  </option>
                )
              })}
            </Input>

            <Label for='trackingNumber' style={{ marginTop: 20 }}>
              Trackingnummer
            </Label>
            <Input
              type='text'
              onChange={t => {
                OrderActions.setTrackingNumber(t.target.value)
              }}
              value={this.state.trackingDetails.trackingNumber}
              name='trackingNumber'
            />

            <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
              <Button onClick={OrderActions.saveTrackingDetails}>Gem</Button>
              <Button
                color='light'
                onClick={() => OrderActions.goToTrackingUrl()}
                disabled={!this.state.trackingDetails.CarrierID || !this.state.trackingDetails.trackingNumber}
              >
                Gå til link
              </Button>
              <Button
                color='light'
                onClick={() => OrderActions.getTrackAndTraceEvents(orderId)}
                disabled={!this.state.trackingDetails.CarrierID || !this.state.trackingDetails.trackingNumber}
              >
                Hent tracking (GLS)
              </Button>
            </div>

            <OrderTrackingHistory events={this.state.trackAndTraceEvents} />
          </CollapsibleCard>

          <CollapsibleCard header={<strong>Afsendelsesdatoer</strong>}>
            <Label for='expectedShipmentDate'>Forventet afsendelsesdato</Label>
            <Input
              type='date'
              onChange={t => {
                OrderActions.setExpectedShipmentDate(t.target.value)
              }}
              value={moment(this.state.orderDetails.expectedShipmentDate).format('YYYY-MM-DD')}
              name='expectedShipmentDate'
            />

            <Label for='overrideShipmentDate' style={{ marginTop: 20 }}>
              Overskriv afsendelsesdato
            </Label>
            <Input
              type='date'
              onChange={t => {
                OrderActions.setOverrideShipmentDate(t.target.value)
              }}
              value={moment(this.state.orderDetails.overrideShipmentDate).format('YYYY-MM-DD')}
              name='overrideShipmentDate'
            />

            <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
              <Button onClick={OrderActions.saveShipmentDates}>Gem</Button>
            </div>
          </CollapsibleCard>

          {this.state.settings &&
            this.state.settings.userRole.toLowerCase() === 'system' &&
            this.state.settings.userPrivilege.toLowerCase() === 'manage' && (
              <CollapsibleCard startOpen header={<strong>Ansvarlig</strong>}>
                <Input
                  type='select'
                  name='assignedUserID'
                  id='assignedUserID'
                  placeholder='Ingen'
                  onChange={e => OrderActions.assignOrder(e.target.value)}
                  value={this.state.orderDetails.assignedUserID}
                >
                  <option key={0} value={null}>
                    Ingen
                  </option>
                  {this.state.msbAdminUsers.map(u => {
                    return (
                      <option key={u.UserID} value={u.UserID}>
                        {u.userName}
                      </option>
                    )
                  })}
                </Input>
              </CollapsibleCard>
            )}
          <CollapsibleCard startOpen header={<strong>Ordrelinjer</strong>}>
            <DynamicTable
              data={order.orderlines}
              responsive
              size='sm'
              showAll
              hideSearch
              headers={{ OrderlineID: '#', orderlineTitle: 'Produkter', userNote: 'Note', actions: ' ' }}
              options={{
                unsortable: ['actions'],
                fieldFunctions: {
                  orderlineTitle: e => {
                    let orderlineTitle = ''
                    let orderlineProductNumber = ''
                    let orderlineProductNumberArray = ''
                    let orderlineVariation = {}
                    if (this.state.isCustomOrder) {
                      // custom-orders don't have product number
                      orderlineTitle = e.orderlineTitle ? e.orderlineTitle : ''
                    } else {
                      // normal orders go in here
                      if (e.orderlineTitle.match(/\((.*)\)/)) {
                        orderlineTitle = e.orderlineTitle.replace(/ *\([^)]*\) */g, ' ')
                      } else {
                        orderlineTitle = e.orderlineTitle
                      }
                      if (
                        e.ProductID &&
                        e.ProductID != 0 &&
                        e.product &&
                        e.product.elementTitle &&
                        e.product.variations &&
                        e.product.variations.length > 0
                      ) {
                        // set product number based on api response
                        orderlineVariation = e.product.variations.filter(item => {
                          return item.VariationID === e.VariationID
                        })
                        if (orderlineVariation.length > 0) {
                          orderlineProductNumber = orderlineVariation[0].variationUID
                        }
                      }
                      if (!orderlineProductNumber) {
                        if (e.orderlineTitle.match(/\((.*)\)/)) {
                          orderlineProductNumberArray = e.orderlineTitle.match(/\((.*)\)/)
                        }
                      }
                    }
                    return (
                      <div>
                        {e.ProductID > 0 ? (
                          <StyledLink to={`/products/${e.ProductID}`}>{orderlineTitle}</StyledLink>
                        ) : (
                          <StyledProductTitleSpan
                            onClick={e => {
                              e.stopPropagation()
                            }}
                          >
                            {orderlineTitle}
                          </StyledProductTitleSpan>
                        )}
                        {orderlineProductNumber && (
                          <StyledSpan
                            onClick={event => {
                              event.stopPropagation()
                              // set display value for title and copy-value for productNumber
                              orderlineProductNumber = orderlineProductNumber
                                ? orderlineProductNumber
                                : orderlineProductNumberArray.length > 0 && orderlineProductNumberArray[1]
                                ? orderlineProductNumberArray[1]
                                : ''
                              navigator.clipboard.writeText(orderlineProductNumber)
                              toast.success('Kopieret: ' + orderlineProductNumber, {
                                autoClose: 3000
                              })
                            }}
                          >
                            {// set display value for productNumber
                            orderlineProductNumber
                              ? ' (' + orderlineProductNumber + ')'
                              : orderlineProductNumberArray.length > 0 && orderlineProductNumberArray[0]
                              ? ' ' + orderlineProductNumberArray[0]
                              : ''}
                          </StyledSpan>
                        )}
                      </div>
                    )
                  },
                  actions: e => {
                    if (e.reservedStock) {
                      return (
                        <React.Fragment>
                          <Button
                            id={'stockInfo' + e.OrderlineID}
                            onClick={() => {
                              OrderActions.releaseStock(e.OrderlineID)
                            }}
                            color='success'
                            style={{ float: 'right' }}
                          >
                            <FontAwesomeIcon icon='warehouse' />
                          </Button>
                          <Tooltip target={'stockInfo' + e.OrderlineID}>Release to stock</Tooltip>
                        </React.Fragment>
                      )
                    }

                    const variation = e.product?.variations?.length
                      ? e.product.variations.find(item => {
                          return item.VariationID === e.VariationID
                        })
                      : null
                    if (variation && variation.variationStock > 0) {
                      return (
                        <React.Fragment>
                          <Button
                            id={'stockInfo' + e.OrderlineID}
                            onClick={() => {
                              OrderActions.reserveStock(e.OrderlineID)
                            }}
                            color='warning'
                            style={{ float: 'right' }}
                          >
                            <FontAwesomeIcon icon='warehouse' />
                          </Button>
                          <Tooltip target={'stockInfo' + e.OrderlineID} placement='left'>{`Reserve from ${
                            variation.externalStock ? 'external' : 'internal'
                          } stock (${variation.variationStock} available)`}</Tooltip>
                        </React.Fragment>
                      )
                    } else {
                      return (
                        <React.Fragment>
                          <Button id={'stockInfo' + e.OrderlineID} style={{ float: 'right', cursor: 'default' }} disabled>
                            <FontAwesomeIcon icon='warehouse' />
                          </Button>
                          <Tooltip target={'stockInfo' + e.OrderlineID} placement='left'>
                            Not in stock
                          </Tooltip>
                        </React.Fragment>
                      )
                    }
                  }
                }
              }}
            />
          </CollapsibleCard>
          <CollapsibleCard startOpen header={<strong>Ordrehistorik</strong>}>
            <DynamicTable
              responsive
              size='sm'
              showAll
              hideSearch
              data={order.timeline}
              headers={{
                TimelineID: '#',
                timeInsert: 'Tid',
                parentRelationID: 'Ordrenummer',
                timelineEvent: 'Begivenhed',
                userName: 'Bruger'
              }}
              options={{
                startSort: { column: 'TimelineID', dir: 'DESC' },
                fieldFunctions: {
                  timeInsert: v => moment(v.timeInsert).format('D/M/YYYY, HH:mm')
                }
              }}
            />
          </CollapsibleCard>

          <OrderCommunication ConfirmationID={order.ConfirmationID} />

          <CollapsibleCard startOpen={true} header={<strong>Kommentarer</strong>}>
            <CommentSection relatedType='Order' relatedID={orderId} />
          </CollapsibleCard>
        </Col>
        <NotifyUserModal
          show={!!this.state.showNotifyModal}
          onHideModal={() => OrderActions.setShowNotifyModal(false)}
          UserID={order.UserID}
          OrderID={order.OrderID}
        />
      </Row>
    )
  }
}

const OrderListOverview = props => {
  return (
    <Fragment>
      <OrderFilters {...props} />
      <OrderList {...props} />
    </Fragment>
  )
}

class OrderList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mouseOver: false
    }
    this.stores = [OrderStore, PurchaseOrderStore]
    this.storeKeys = [
      'orders',
      'orderFilter',
      'fetchingOrders',
      'selectedOrders',
      'selectedOrderLines',
      'filterText',
      'orderStatus',
      'showClipBoardMessage',
      'c5SelectedOrders',
      'previewOrders',
      'isAllChecked',
      'isAllOrderLinesChecked',
      'isIndeterminate',
      'scrollPosition',
      'paginationPoint',
      'paginationAmount',
      'refundedOrder',
      'c5SupplierError',
      'showRefundModal',
      'refundFreight',
      'addRefundToStock',
      'showNotifyModal',
      'notifyUserID',
      'OrderID',
      'totalOrders',
      'sortData'
    ]
    this.orderStatus = this.props.seasonOrder ? seasonOrderStatus : orderStatus
  }
  componentDidMount() {
    if (this.props.filterOrderID) {
      //OrderActions.addFilter({column: 'OrderID', operator: 'LIKE', value: this.props.filterOrderID})
      OrderActions.getOrders(true, [{ column: 'OrderID', operator: 'LIKE', value: this.props.filterOrderID }])
    } else {
      OrderActions.setOrderFilter(this.props.seasonOrder ? 'seasonOrder' : 'order')
      OrderActions.getOrders()
    }
  }
  componentDidUpdate() {
    if (this.state.orderStatus === false) {
      toast.error('Unable to change the status', {
        autoClose: 7500,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
    }
    if (this.state.orderStatus) {
      toast.success('Status Changed Successfully', {
        autoClose: 7500,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
      OrderActions.clearToast()
    }
    if (this.state.showClipBoardMessage) {
      toast.success('Kopieret', {
        autoClose: 7500,
        onClose: () => {
          OrderActions.clearToast()
        }
      })
      OrderActions.clearToast()
    }
  }
  hoverOn = () => {
    if (!this.state.mouseOver) {
      this.setState({ mouseOver: true })
    }
  }
  hoverOff = () => {
    if (this.state.mouseOver) {
      this.setState({ mouseOver: false })
    }
  }

  createPurchaseOrder() {
    OrderActions.generatePurchaseOrder(this.state.c5SelectedOrders)
  }

  showStockAmountIcon = order => {
    const processingStatuses = ['NEW', 'TENTATIVE', 'BACKORDER', 'ORDERED', 'PACKED']
    return processingStatuses.some(s => s === order.orderFlowStatus)
  }
  render() {
    let tableFieldStringFunctions = {
      timeInsert: e => {
        return e.timeInsert
      },
      orderLabel: e => {
        return e.orderLabel
      },
      orderConsignee: e => {
        return e.orderConsignee
      },
      orderComment: e => {
        return e.orderComment
      },
      trackingDetails: e => {
        return e.trackingDetails ? e.trackingDetails.trackingNumber : ''
      },
      brandName: e => {
        return e.originBrand ? e.originBrand.brandName : ''
      },
      status: e => {
        return e.orderFlowStatus
      },
      products: e => {
        let rVal = e.orderlines.map(ol => {
          let supplier = ol.product && ol.product.supplier ? ol.product.supplier.supplierName : ''
          return [ol.orderlineTitle, ol.manufacturer, supplier].join(' ')
        })
        return rVal.join(' ')
      }
    }
    const OrderlineView = props => {
      const ol = props.ol
      const olGroupValue = `${ol.orderlineTitle}#${ol.reservedStock}`
      const orderlines = props.order.orderlines.filter(line => `${line.orderlineTitle}#${line.reservedStock}` === olGroupValue)
      const supplier = ol.product && ol.product.supplier ? ol.product.supplier.supplierName : null
      if (ol.orderlineTitleNew && !props.order.orderCustomOrder) {
        if (ol.orderlineTitleNew.match(/\((.*)\)/)) {
          ol.orderLineTitleProductID = ol.orderlineTitleNew.match(/\((.*)\)/)
          ol.orderlineTitleNew = ol.orderlineTitleNew.replace(/ *\([^)]*\) */g, ' ')
        }
      }
      return (
        <StyledSpan value={this.state.mouseOver} onMouseMove={() => this.hoverOff()}>
          <OrderLineCheckbox
            className='mr-2'
            type='checkbox'
            checked={
              this.state.selectedOrderLines.findIndex(i => {
                return i == ol.OrderlineID
              }) > -1
            }
            onChange={() => {
              OrderActions.selectOrderLine(ol.OrderlineID, ol.grouped ? orderlines : [])
            }}
            style={{ cursor: 'pointer' }}
          />
          {!!ol.reservedStock && !ol.externalStock && (
            <span className='mx-1'>
              <Tooltip target={'catInternalStock' + ol.OrderlineID}>{`Reserved internal stock ${
                ol.stockLocationName ? `(${ol.stockLocationName})` : ''
              }`}</Tooltip>
              <Badge id={'catInternalStock' + ol.OrderlineID} pill color='success' style={{ cursor: 'default' }}>
                {ol.stockLocationName ? ol.stockLocationName : <FontAwesomeIcon icon='warehouse' />}
              </Badge>
            </span>
          )}
          {this.showStockAmountIcon(props.order) && !ol.reservedStock && !ol.externalStock && ol.variationStock > 0 && (
            <span className='mx-1'>
              <Tooltip target={'catInternalStock' + ol.OrderlineID}>{ol.variationStock} available in internal stock</Tooltip>
              <Badge id={'catInternalStock' + ol.OrderlineID} pill color='warning' style={{ cursor: 'default' }}>
                {ol.variationStock}
              </Badge>
            </span>
          )}
          <span>
            <StyledLink to={`products/${ol.ProductID}`}>{ol.orderlineTitleNew}</StyledLink>
            {ol.orderLineTitleProductID && (
              <React.Fragment>
                <StyledProductNumberSpan
                  onMouseMove={e => {
                    e.stopPropagation()
                    this.hoverOn()
                  }}
                  onMouseLeave={e => {
                    e.stopPropagation()
                    this.hoverOff()
                  }}
                  onClick={e => {
                    e.stopPropagation()
                    navigator.clipboard.writeText(ol.orderLineTitleProductID[1])
                    toast.success('Kopieret: ' + ol.orderLineTitleProductID[1], {
                      autoClose: 3000
                    })
                  }}
                >
                  {ol.orderLineTitleProductID[0]}
                </StyledProductNumberSpan>
              </React.Fragment>
            )}
          </span>
          {!!ol.reservedStock && !!ol.externalStock && (
            <span className='mx-1'>
              <Tooltip target={'catExternalStock' + ol.OrderlineID}>Reserved external stock</Tooltip>
              <Badge id={'catExternalStock' + ol.OrderlineID} pill color='warning' style={{ cursor: 'default' }}>
                E
              </Badge>
            </span>
          )}
          {ol.manufacturer && (
            <span className='mx-1'>
              <Tooltip target={'catManufacturer' + ol.OrderlineID}>Producent</Tooltip>
              <Badge
                pill
                id={'catManufacturer' + ol.OrderlineID}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  OrderActions.addFilter({ column: 'manufacturer', value: ol.manufacturer }, true)
                }}
                color='primary'
              >
                {ol.manufacturer}
              </Badge>
            </span>
          )}
          {supplier && (
            <span className='mx-1'>
              <Tooltip target={'catSupplier' + ol.OrderlineID}>Leverandør</Tooltip>
              <Badge
                pill
                id={'catSupplier' + ol.OrderlineID}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  OrderActions.addFilter({ column: 'supplier', value: supplier }, true)
                }}
                color='info'
              >
                {supplier}
              </Badge>
            </span>
          )}
          {ol.purchaseOrderIDs && ol.purchaseOrderIDs.length > 1 && (
            <span className='mx-1'>
              <Tooltip target={'catPO' + ol.OrderlineID}>Findes på flere POer</Tooltip>
              <Badge pill id={'catPO' + ol.OrderlineID} style={{ cursor: 'pointer' }} color='danger'>
                !
              </Badge>
            </span>
          )}
          / {ol.orderAmountPoints ? `${ol.orderAmountPoints} point` : `${ol.orderAmountCurrency.toFixed(2)} kr`}
          {ol.InvoiceID != '0' && (
            <Link title={`Faktura ID: ${ol.InvoiceID}`} to={'/admininvoice/' + props.originBrandID + '/' + ol.InvoiceID} style={{ color: 'orange' }}>
              <FontAwesomeIcon fixedWidth icon='file-alt' />
            </Link>
          )}
          {ol.grouped && (
            <span
              onClick={() => {
                OrderActions.expandOrderlines(ol)
              }}
            >
              <FontAwesomeIcon style={{ color: 'orange' }} fixedWidth icon='toggle-on' />
            </span>
          )}
          {ol.grouped === false && (
            <span
              onClick={() => {
                OrderActions.collapseOrderlines(ol)
              }}
            >
              <FontAwesomeIcon style={{ color: 'orange' }} fixedWidth icon='toggle-off' />
            </span>
          )}
        </StyledSpan>
      )
    }
    const paginatedTableOptions = {
      showAdminAccessDropdown: true,
      copyHightlighText: true,
      getdata: OrderActions.getOrders,
      setFilterText: OrderActions.setFilterText,
      setAllChecked: OrderActions.setAllChecked,
      setPaginationPoint: OrderActions.setPaginationPoint,
      setPaginationAmount: OrderActions.setPaginationAmount,
      setSortData: OrderActions.setSortData,
      filterText: this.state.filterText,
      paginationPoint: this.state.paginationPoint,
      paginationAmount: this.state.paginationAmount,
      loading: this.state.fetchingOrders,
      totalamount: this.state.totalOrders,
      sortData: this.state.sortData,
      unsortable: ['actions', 'orderLabel', 'brandName', 'trackingDetails', 'OrderID'],
      fieldStringFunctions: tableFieldStringFunctions,
      fieldExportFunctions: tableFieldStringFunctions,
      fieldFunctions: {
        OrderID: e => {
          return (
            <Input
              className='order-selection'
              type='checkbox'
              id={'checkbox' + e.OrderID}
              name={'checkbox' + e.OrderID}
              checked={e.checked}
              onChange={event => {
                OrderActions.selectOrderHandler(event, e.OrderID)
              }}
            />
          )
        },
        brandName: e => {
          return (
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => {
                OrderActions.fastFilter(
                  { filterID: 0, column: 'originBrandID', value: e.originBrandID },
                  { column: 'originBrandID', value: e.originBrand.brandName }
                )
              }}
            >
              {e.originBrand ? e.originBrand.brandName : ''}
            </span>
          )
        },
        timeInsert: e => {
          return (
            <Fragment>
              <Tooltip target={'orderStatus' + e.OrderID}>{this.orderStatus[e.orderFlowStatus]}</Tooltip>
              <FontAwesomeIcon
                size='lg'
                icon={isOurID(e.UserID) ? 'ban' : 'tag'}
                id={'orderStatus' + e.OrderID}
                style={{ color: statusColors[e.orderFlowStatus], cursor: 'default' }}
                fixedWidth
              />
              {moment(e.timeInsert).format('YYYY-MM-DD')}
            </Fragment>
          )
        },
        orderLabel: e => {
          return (
            <Fragment>
              <Tooltip target={'orderLabel' + e.OrderID}>Ordredel: {e.orderPart}</Tooltip>
              <span
                id={'orderLabel' + e.OrderID}
                onClick={event => {
                  event.stopPropagation()
                  navigator.clipboard.writeText(e.OrderID)
                  toast.success('Kopieret: ' + e.OrderID, {
                    autoClose: 3000
                  })
                }}
              >
                {e.orderLabel}
              </span>
            </Fragment>
          )
        },
        orderConsignee: e => {
          return (
            <Fragment>
              <StyledLink to={`users/${e.UserID}`}>{e.orderConsignee}</StyledLink>{' '}
              {e.siblings > 1 && (
                <span
                  style={{ color: 'orange', cursor: 'pointer' }}
                  onClick={() => {
                    OrderActions.clearFilters()
                    OrderActions.addFilter({ filterID: 0, column: 'orderFlowStatus', value: 'NEW' })
                    OrderActions.addFilter({ filterID: 0, column: 'orderFlowStatus', value: 'TENTATIVE' })
                    OrderActions.addFilter({ filterID: 0, column: 'orderFlowStatus', value: 'BACKORDER' })
                    OrderActions.addFilter({ filterID: 0, column: 'orderFlowStatus', value: 'ORDERED' })
                    OrderActions.addFilter({ filterID: 0, column: 'orderFlowStatus', value: 'PACKED' })
                    OrderActions.addFilter({ filterID: 1, column: 'UserID', value: e.UserID }, true)
                  }}
                >
                  <FontAwesomeIcon icon={['far', 'user']} /> {e.siblings}
                </span>
              )}
            </Fragment>
          )
        },
        orderComment: e => {
          return <OrderCommentTooltip order={e} />
        },
        trackingDetails: e => {
          if (!e.trackingDetails) {
            return null
          }
          return (
            <Fragment>
              <a href={e.trackingDetails.trackingPrefix + e.trackingDetails.trackingNumber} target='_blank' rel='noopener noreferrer'>
                {e.trackingDetails.trackingNumber}
                <br />
              </a>
            </Fragment>
          )
        },
        products: e => {
          let finalOrderlines = []
          if (e.orderlines.length > 1) {
            const orderlinesGrouped = _.groupBy(e.orderlines, ol => `${ol.orderlineTitle}#${ol.reservedStock}`)
            for (const i in orderlinesGrouped) {
              const originalOrderlines = orderlinesGrouped[i]
              let orderlines = Array.from(originalOrderlines)

              if (orderlines.length > 1) {
                const finalOrderline = { ...orderlines[0] }
                if (finalOrderline.grouped === undefined || finalOrderline.grouped) {
                  finalOrderline.orderlineTitleNew = orderlines.length + ' x ' + finalOrderline.orderlineTitle
                  finalOrderline.grouped = true
                  finalOrderlines.push(finalOrderline)
                } else {
                  let orderlinesExpanded = orderlines.map(ol => {
                    ol.grouped = false
                    ol.orderlineTitleNew = '1 x ' + ol.orderlineTitle
                    return ol
                  })
                  finalOrderlines = finalOrderlines.concat(orderlinesExpanded)
                }
              } else {
                let finalOrderline = { ...orderlines[0] }
                finalOrderline.orderlineTitleNew = '1 x ' + finalOrderline.orderlineTitle
                finalOrderlines.push(finalOrderline)
              }
            }
          } else {
            let finalOrderline = { ...e.orderlines[0] }
            finalOrderline.orderlineTitleNew = '1 x ' + finalOrderline.orderlineTitle
            finalOrderlines.push(finalOrderline)
          }
          const totalFreightPoints = (e.freightPoints || 0) + (e.dropshipPoints || 0)
          const totalOrderAmountPoints = e.orderlines.reduce((sum, line) => sum + (line.orderAmountPoints || 0), 0)

          const totalFreightCurrency = (e.freightPriceDKK || 0) + (e.dropshipPriceDKK || 0)
          const totalOrderAmountCurrency = e.orderlines.reduce((sum, line) => sum + (line.orderAmountCurrency || 0), 0)
          const totalAmountCurrencyWithFreight = totalOrderAmountCurrency + totalFreightCurrency

          const showPriceInPoints = totalOrderAmountPoints > 0
          const showDeliveryCostInPoints = showPriceInPoints && !e.deliveryPaidWithCard

          const totalAmountPointsWithFreight = showDeliveryCostInPoints ? totalOrderAmountPoints + totalFreightPoints : totalOrderAmountPoints

          return (
            <Fragment>
              {finalOrderlines.map((ol, iOL) => {
                return (
                  <Fragment key={iOL}>
                    <OrderlineView ol={ol} originBrandID={e.originBrandID} order={e}></OrderlineView>
                    <br />
                  </Fragment>
                )
              })}
              {(totalFreightPoints > 0 || totalFreightCurrency > 0) && (
                <span>
                  <i>Total fragt: {showDeliveryCostInPoints ? `${totalFreightPoints} point` : `${totalFreightCurrency} kr`}</i>
                </span>
              )}
              <span>
                <br />
                <i>Total: {showPriceInPoints ? `${totalAmountPointsWithFreight} point` : `${totalAmountCurrencyWithFreight.toFixed(2)} kr`}</i>
              </span>
            </Fragment>
          )
        },
        orderFlowStatus: e => {
          return (
            <Fragment>
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  style={{
                    background: statusColors[e.orderFlowStatus],
                    color: orderColors[e.orderFlowStatus] ? orderColors[e.orderFlowStatus] : 'black'
                  }}
                >
                  <span>{this.orderStatus[e.orderFlowStatus]}</span>
                </DropdownToggle>
                <DropdownMenu style={{ overflow: 'visible' }}>
                  {Object.keys(this.orderStatus).map((s, is) => {
                    return (
                      <StyledDropdown
                        onClick={item => {
                          if (confirm('Do you want to change order status?')) {
                            OrderActions.updateOrderInstant(item, e)
                          }
                        }}
                        value={s}
                        key={is}
                        style={{ background: statusColors[s], color: orderColors[s] ? orderColors[s] : 'black' }}
                      >
                        {this.orderStatus[s]}
                      </StyledDropdown>
                    )
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Fragment>
          )
        },
        assignedUserID: e => {
          return e.assignedUserName
        },
        actions: e => {
          return (
            <Fragment>
              <ButtonGroup>
                {!this.props.isPopUp && (
                  <div>
                    <Tooltip target={'edit' + e.OrderID}>Rediger</Tooltip>
                    <span onClick={OrderActions.handleClick}>
                      <Button data-cy='order.editBtn' tag={Link} id={'edit' + e.OrderID} to={`${this.props.location.pathname}/` + e.OrderID}>
                        <FontAwesomeIcon icon='edit' />
                      </Button>
                    </span>
                  </div>
                )}
                <Tooltip target={'print' + e.OrderID}>Print</Tooltip>
                <Button
                  id={'print' + e.OrderID}
                  onClick={() => {
                    window.open('/orders/print?OrderID=' + e.OrderID, '_blank')
                  }}
                >
                  <FontAwesomeIcon icon='print' />
                </Button>
                <Tooltip target={'ship' + e.OrderID}>Send</Tooltip>
                <Button
                  id={'ship' + e.OrderID}
                  onClick={() => {
                    OrderActions.shipOrder(e.OrderID)
                  }}
                  disabled={e.orderRefunded == 1}
                  color='success'
                >
                  <FontAwesomeIcon icon='ship' />
                </Button>
                {!this.props.isPopUp && (
                  <Fragment>
                    <Tooltip target={'notify' + e.OrderID}>Send besked</Tooltip>
                    <Button
                      id={'notify' + e.OrderID}
                      onClick={() => {
                        OrderActions.setShowNotifyModal(true, e.OrderID, e.UserID)
                      }}
                      style={this.props.style}
                    >
                      <span className='fa-layers fa-fw'>
                        <FontAwesomeIcon icon='mail-bulk' />
                      </span>
                    </Button>
                  </Fragment>
                )}

                {!this.props.seasonOrder && !this.props.isPopUp && (
                  <Fragment>
                    <Tooltip target={'refund' + e.OrderID}>Refunder</Tooltip>
                    <Button
                      id={'refund' + e.OrderID}
                      onClick={() => {
                        // if (confirm('Vil du refundere denne ordre?')) {
                        //   OrderActions.refundOrder(e.OrderID)
                        // }
                        OrderActions.setShowRefundModal(true, e.OrderID)
                      }}
                      disabled={e.orderRefunded == 1 || (this.state.refundedOrder && this.state.refundedOrder[e.OrderID])}
                      color='danger'
                    >
                      <span className='fa-layers fa-fw'>
                        <FontAwesomeIcon icon='hand-holding-usd' />
                        {e.orderRefunded == 1 && <FontAwesomeIcon icon='ban' size='lg' />}
                      </span>
                    </Button>
                    <Modal
                      isOpen={!!this.state.showRefundModal && this.state.OrderID === e.OrderID}
                      toggle={() => OrderActions.setShowRefundModal(!this.state.showRefundModal)}
                      size='md'
                    >
                      <ModalHeader toggle={() => OrderActions.setShowRefundModal(!this.state.showRefundModal)}>Bekræft refundering</ModalHeader>
                      <ModalBody>
                        <p>Vil du refundere denne ordre?</p>

                        {e.freightPoints + e.dropshipPoints > 0 && (
                          <Row style={{ padding: '19px', marginBottom: '25px' }}>
                            <Col>
                              <Input
                                className='order-selection'
                                type='checkbox'
                                id={'refundFreight' + e.OrderID}
                                name={'refundFreight' + e.OrderID}
                                onChange={event => {
                                  OrderActions.setRefundFreight(event)
                                }}
                              />
                              <Label style={{ marginLeft: 32, marginTop: 0 }}>Fragt skal refunderes {e.freightPoints + e.dropshipPoints} pt</Label>
                            </Col>
                          </Row>
                        )}

                        <Row style={{ padding: '19px', marginBottom: '25px' }}>
                          <Col>
                            <Input
                              className='order-selection'
                              type='checkbox'
                              id={'addToStock' + e.OrderID}
                              name={'addToStock' + e.OrderID}
                              onChange={event => {
                                OrderActions.setAddRefundToStock(event)
                              }}
                            />
                            <Label style={{ marginLeft: 32, marginTop: 0 }}>Tilføj produkter til lagerbeholdning</Label>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <Button onClick={() => OrderActions.refundOrder(e.OrderID, this.state.refundFreight, this.state.addRefundToStock)}>Ok</Button>
                      </ModalFooter>
                    </Modal>
                  </Fragment>
                )}
              </ButtonGroup>
            </Fragment>
          )
        }
      }
    }
    return (
      <Fragment>
        <Card>
          <CardHeader>
            <Row>
              <Col>
                <span data-cy='order.title'>{this.props.seasonOrder ? 'Season Order' : 'Ordrer'}</span>
              </Col>
              {!this.props.seasonOrder && !this.props.isPopUp && (
                <Col md='auto'>
                  <Button onClick={OrderActions.getSelectedOrders} disabled={!this.state.selectedOrderLines.length}>
                    {' '}
                    Opret PO{' '}
                  </Button>
                </Col>
              )}
              <Col md='2'>
                <Input
                  type='select'
                  name='orderFlowStatus'
                  id='orderFlowStatus'
                  onChange={item => {
                    let bulkSelectedOrders = this.state.orders.filter(elem => elem.checked)

                    if (bulkSelectedOrders.length > 0 && !this.state.selectedOrderLines.length) {
                      if (bulkSelectedOrders.length > 0) {
                        if (confirm('Do you want to change the status of selected orders?')) {
                          OrderActions.bulkUpdateSeasonOrderStatus(item, bulkSelectedOrders)
                        } else {
                          item.target.value = false // reset the dropdown
                        }
                      } else {
                        item.target.value = false // reset the dropdown
                        toast.error('No orders were selected.', {
                          autoClose: 7000,
                          onClose: () => {
                            OrderActions.clearToast()
                          }
                        })
                      }
                    } else if (this.state.selectedOrderLines.length && !bulkSelectedOrders.length) {
                      if (confirm('Do you want to split/merge selected orderlines?')) {
                        OrderActions.updateOrderGlobal(item.target.value, this.orderStatus)
                      }
                      item.target.value = false // reset the dropdown
                    } else if (this.state.selectedOrderLines.length && bulkSelectedOrders.length) {
                      item.target.value = false // reset the dropdown
                      toast.error('Order(s) and Orderline(s) cannot be selected simultaneously for this action.', {
                        autoClose: 7000,
                        onClose: () => {
                          OrderActions.clearToast()
                        }
                      })
                    } else {
                      item.target.value = false // reset the dropdown
                      toast.error('No orders were selected.', {
                        autoClose: 7000,
                        onClose: () => {
                          OrderActions.clearToast()
                        }
                      })
                    }
                  }}
                >
                  <option selected='true' disabled={true} value={false}>
                    Change Status
                  </option>
                  {Object.keys(this.orderStatus).map((s, is) => {
                    return (
                      <option key={is} value={s}>
                        {this.orderStatus[s]}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {/* {!this.props.seasonOrder && (
              <Row style={{ padding: '19px', marginBottom: '25px' }}>
                <Col xs={3}>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id={'checkbox'}
                    name={'checkbox'}
                    checked={this.state.isAllOrderLinesChecked}
                    onChange={e => {
                      OrderActions.selectAllOrderLines(e)
                    }}
                    ref={input => {
                      if (input) {
                        input.indeterminate = this.state.isIndeterminate
                      }
                    }}
                  />
                  <Label check htmlFor={'checkbox'}>
                    Select All Orderlines
                  </Label>
                </Col>
              </Row>
            )} */}
            {this.props.seasonOrder && (
              <PaginatedTable
                responsive
                size='sm'
                data-cy='order.table'
                data={this.state.orders}
                headers={{
                  OrderID: ' ',
                  timeInsert: 'Dato',
                  orderLabel: '#',
                  brandName: 'Klub',
                  orderConsignee: 'Bruger',
                  products: 'Produkter',
                  orderComment: 'Note',
                  trackingDetails: 'Trackingnummer',
                  orderFlowStatus: 'Status',
                  AddressID: 'Address',
                  assignedUserID: 'Ansvarlig',
                  actions: ' '
                }}
                options={paginatedTableOptions}
              />
            )}
            {!this.props.seasonOrder && (
              <PaginatedTable
                responsive
                {...(this.state.isAllChecked && { showAll: true })}
                size='sm'
                data-cy='order.table'
                data={this.state.orders}
                headers={{
                  OrderID: ' ',
                  timeInsert: 'Dato',
                  orderLabel: '#',
                  brandName: 'Klub',
                  orderConsignee: 'Bruger',
                  products: 'Produkter',
                  orderComment: 'Note',
                  trackingDetails: 'Trackingnummer',
                  orderFlowStatus: 'Status',
                  assignedUserID: 'Ansvarlig',
                  actions: ' '
                }}
                options={paginatedTableOptions}
              />
            )}
            <Modal isOpen={this.state.previewOrders} toggle={() => OrderActions.logoutModal()} size='xl'>
              <ModalHeader toggle={() => OrderActions.logoutModal()}>OrderLines</ModalHeader>
              <ModalBody>
                {/* Replace DynamicTable with MUI Table */}
                <TableContainer component={Paper}>
                  <Table size='large' style={{ width: '100%' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Produkt</TableCell>
                        <TableCell>Varenummer</TableCell>
                        <TableCell>Antal</TableCell>
                        <TableCell style={{ minWidth: 320 }}>Adresse</TableCell>
                        <TableCell>Leverandør</TableCell>
                        <TableCell>Bestilt</TableCell>
                        <TableCell>PO ID</TableCell>
                        <TableCell>Pris</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(this.state.c5SelectedOrders || []).map((row, idx) => (
                        <TableRow key={row.OrderlineID || idx}>
                          <TableCell>{row.productTitle}</TableCell>
                          <TableCell>{row.variationUID}</TableCell>
                          <TableCell>{row.count}</TableCell>
                          <TableCell style={{ minWidth: 320, whiteSpace: 'pre-line' }}>{row.address}</TableCell>
                          <TableCell>{row.vendor}</TableCell>
                          <TableCell>
                            {row.onPurchaseOrder === 'YES' ? (
                              <span style={{ color: 'green', fontWeight: 600 }}>Ja</span>
                            ) : (
                              <span style={{ color: 'red', fontWeight: 600 }}>Nej</span>
                            )}
                          </TableCell>
                          <TableCell>
                            {Array.isArray(row.purchaseOrderIDs) && row.purchaseOrderIDs.length > 0
                              ? row.purchaseOrderIDs.map((id, i) => (
                                  <Fragment key={id}>
                                    <StyledLink to={`/purchase-orders/details/${id}`}>{id}</StyledLink>
                                    {i < row.purchaseOrderIDs.length - 1 ? ', ' : null}
                                  </Fragment>
                                ))
                              : '-'}
                          </TableCell>
                          <TableCell>{Number(row.productPrice).toLocaleString('da-DK', { minimumFractionDigits: 2 })} DKK</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: 'right', fontWeight: 600 }}>
                          Total
                        </TableCell>
                        <TableCell style={{ fontWeight: 600 }}>
                          {(this.state.c5SelectedOrders || [])
                            .reduce((sum, row) => sum + Number(row.productPrice) * Number(row.count), 0)
                            .toLocaleString('da-DK', { minimumFractionDigits: 2 })}{' '}
                          DKK
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => this.createPurchaseOrder()} disabled={!this.state.c5SelectedOrders.length}>
                  Opret PO
                </Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={!!this.state.c5SupplierError} toggle={() => OrderActions.clearC5Error()} size='md'>
              <ModalHeader toggle={() => OrderActions.clearC5Error()}>Error</ModalHeader>
              <ModalBody>
                <p>{this.state.c5SupplierError}</p>
              </ModalBody>
              <ModalFooter>
                <Button onClick={OrderActions.clearC5Error}>Ok</Button>
              </ModalFooter>
            </Modal>
          </CardBody>
        </Card>

        <NotifyUserModal
          show={!!this.state.showNotifyModal}
          onHideModal={() => OrderActions.setShowNotifyModal(false)}
          UserID={this.state.notifyUserID}
          OrderID={this.state.OrderID}
        />
      </Fragment>
    )
  }
}

const StyledButton = styled(Button)`
  background: ${props => props.selected && '#716ACA'} !important;
`
class OrderFilters extends Component {
  constructor(props) {
    super(props)
    this.store = OrderStore
    this.storeKeys = [
      'filters',
      'seasonOrderFilters',
      'filterName',
      'suppliers',
      'manufacturers',
      'dynamicFilters',
      'predefinedFilters',
      'orderFilter',
      'seasonOrderPredefinedFilters'
    ]
    this.orderStatus = this.props.seasonOrder ? seasonOrderStatus : orderStatus
  }
  componentDidMount() {
    OrderActions.setOrderFilter(this.props.seasonOrder ? 'seasonOrder' : 'order')
    if ((this.state.suppliers && this.state.suppliers.length == 0) || !this.state.suppliers) {
      OrderActions.getSuppliers()
    }
    if ((this.state.manufacturers && this.state.manufacturers.length == 0) || !this.state.manufacturers) {
      OrderActions.getManufacturers()
    }
  }
  handleKeypress = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      OrderActions.applyFilters()
    }
  }
  render() {
    const predefinedFilters = this.props.seasonOrder ? this.state.seasonOrderPredefinedFilters : this.state.predefinedFilters
    let filterFields = {
      OrderID: 'Ordrenummer',
      ConfirmationID: 'Confirmation nummer',
      orderFlowStatus: 'Ordrestatus',
      supplier: 'Leverandør',
      manufacturer: 'Producent',
      variationid: 'Varenummer',
      productname: 'Vare Navn',
      UserID: 'Bruger ID',
      userName: 'Bruger Navn',
      originBrandID: 'Brand ID',
      ProductID: 'Produktnummer',
      orderConsigneeEmail: 'User Email',
      orderConsigneePhone: 'User Phone Number',
      AddressID: 'Address',
      orderConsigneeName: 'Company',
      assignedUserID: 'Ansvarlig bruger ID'
    }
    if (!this.state || !this.state.suppliers || !this.state.manufacturers) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <Card>
        <CardHeader tag='h4'>Filtre</CardHeader>
        <CardBody>
          <Table responsive size='sm'>
            <thead>
              <tr>
                <th>Kilde</th>
                <th>Operator</th>
                <th>Værdi</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state[this.state.filterName].map((e, i) => {
                let filter = (
                  <Input
                    type='text'
                    onKeyDown={this.handleKeypress}
                    onChange={t => {
                      OrderActions.updateFilter(e, t)
                    }}
                    value={e.value}
                    name='value'
                  />
                )
                switch (e.column) {
                  case 'orderFlowStatus':
                    filter = (
                      <Input
                        type='select'
                        onChange={t => {
                          OrderActions.updateFilter(e, t)
                        }}
                        value={e.value}
                        name='value'
                        style={{ color: statusColors[e.value] }}
                      >
                        <option value=''>Vælg</option>
                        {Object.keys(this.orderStatus).map((s, is) => {
                          return (
                            <option key={is} value={s}>
                              {this.orderStatus[s]}
                            </option>
                          )
                        })}
                      </Input>
                    )
                    break
                  case 'supplier':
                    filter = (
                      <Input
                        type='select'
                        onChange={t => {
                          OrderActions.updateFilter(e, t)
                        }}
                        value={e.value}
                        name='value'
                      >
                        <option value=''>Vælg</option>
                        {this.state.suppliers.map((s, is) => {
                          return <option key={is}>{s.supplierName}</option>
                        })}
                      </Input>
                    )
                    break
                  case 'manufacturer':
                    filter = (
                      <Input
                        type='select'
                        onChange={t => {
                          OrderActions.updateFilter(e, t)
                        }}
                        value={e.value}
                        name='value'
                      >
                        <option value=''>Vælg</option>
                        {this.state.manufacturers.map((s, is) => {
                          //return <option key={is} value={s.CategoryID}>{s.categoryName}</option>
                          return <option key={is}>{s.categoryName}</option>
                        })}
                      </Input>
                    )
                    break
                }
                let column = (
                  <Input
                    type='select'
                    onChange={t => {
                      OrderActions.updateFilter(e, t)
                    }}
                    value={e.column}
                    name='column'
                  >
                    <option value='' disabled>
                      Vælg
                    </option>
                    {Object.keys(filterFields).map((s, is) => {
                      return (
                        <option key={is} value={s}>
                          {filterFields[s]}
                        </option>
                      )
                    })}
                  </Input>
                )
                let operator = 'måske noget her'
                if (
                  e.column &&
                  (e.column === 'productname' ||
                    e.column === 'userName' ||
                    e.column === 'orderConsigneePhone' ||
                    e.column === 'orderConsigneeEmail' ||
                    e.column === 'variationid' ||
                    e.column === 'manufacturer' ||
                    e.column === 'orderConsigneeName' ||
                    e.column === 'supplier')
                ) {
                  operator = 'indeholder'
                } else {
                  operator = 'lig med'
                }
                return (
                  <tr key={i}>
                    <td>{column}</td>
                    <td>{operator}</td>
                    <td onKeyDown={this.handleKeypress}>{filter}</td>
                    <td>
                      <Button
                        onClick={() => {
                          OrderActions.removeFilter(e.column)
                        }}
                      >
                        <FontAwesomeIcon icon='minus' />
                      </Button>
                    </td>
                  </tr>
                )
              })}
              <tr>
                <td colSpan='3'></td>
                <td>
                  <Button onClick={OrderActions.addFilter}>
                    <FontAwesomeIcon icon='plus' />
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <React.Fragment>
            {this.state[this.state.filterName].length > 0 && <Button onClick={OrderActions.applyFilters}>Filtrér</Button>}
          </React.Fragment>
          <React.Fragment>
            {this.state[this.state.filterName].length > 0 && (
              <Button
                color='danger'
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  OrderActions.clearFilters()
                  OrderActions.applyFilters()
                }}
              >
                Nulstil filtre
              </Button>
            )}
          </React.Fragment>
          <AreaSeperator row />
          <h6>Prædefinerede filtre</h6>
          <ButtonGroup>
            {predefinedFilters.map((item, index) => {
              return (
                <StyledButton
                  className='m-1'
                  key={index}
                  selected={item.selected}
                  onClick={() => {
                    item.selected = !item.selected
                    if (item.selected) {
                      OrderActions.fastFilter({ filterID: 0, column: item.column, value: item.value })
                    } else {
                      OrderActions.removePreDefinedFilter({ filterID: 0, column: item.column, value: item.value })
                    }
                  }}
                >
                  {item.name}
                </StyledButton>
              )
            })}
          </ButtonGroup>
          <br />
        </CardBody>
      </Card>
    )
  }
}

class OrderCommentTooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      commentCreated: false
    }
  }

  render() {
    const hasComment = this.state.commentCreated || this.props.order.hasComments || this.props.order.orderComment
    return (
      <Fragment>
        <Button id={'orderComment' + this.props.order.OrderID} type='button' color={''}>
          <FontAwesomeIcon icon='sticky-note' color={hasComment ? 'black' : 'LightGray'} />
        </Button>

        <UncontrolledPopover target={'orderComment' + this.props.order.OrderID} trigger='legacy'>
          <PopoverHeader>Kommentarer</PopoverHeader>
          <PopoverBody style={{ padding: '8px 14px 14px 14px', maxHeight: 400, overflow: 'auto' }}>
            {!!this.props.order.orderComment && (
              <div style={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                <b>Note:</b>
                {nl2br(this.props.order.orderComment)}
              </div>
            )}

            <div style={{ marginTop: 20 }}>
              <CommentSection
                relatedType='Order'
                relatedID={this.props.order.OrderID}
                commentCreateCallback={() => this.setState({ commentCreated: true })}
              />
            </div>
          </PopoverBody>
        </UncontrolledPopover>
      </Fragment>
    )
  }
}

export { OrderList }
